export default "__VITE_PUBLIC_ASSET__9586cc6b__"